<script>
import { ref } from 'vue'; // Import the new reactive API for managing reactivity
import ConsentBanner from './ConsentBanner.vue';
import ConsentConfig from './ConsentConfig.vue';

const STORAGE_ITEM_NAME = 'CONSENT';

export default {
  components: { ConsentConfig, ConsentBanner },
  data() {
    return {
      bannerIsOpen: ref(false),
      configIsOpen: ref(false),
      consent: ref({
        statistics: false,
        other: false,
        timestamp: null,
        initDecision: null
      }),
      decision: ref(false)
    };
  },
  created() {
    this.load();
    const settingsButton = document.getElementById('consent-settings-button');

    if (settingsButton) {
      settingsButton.addEventListener('click', () => {
        this.openConfig();
      });
    }
  },
  methods: {
    closeConfig() {
      this.configIsOpen = false;
    },
    openConfig() {
      this.configIsOpen = true;
    },
    finalize() {
      window.dataLayer.push({
        event: 'user consent',
        consentStatistics: this.consent.statistics,
        consentRetargeting: this.consent.other
      });
    },
    saveChoice(opts) {
      this.consent = {
        timestamp: new Date(),
        statistics: opts.statistics,
        other: opts.other,
        initDecision: this.consent.initDecision === null
      };
      window.localStorage.setItem(STORAGE_ITEM_NAME, JSON.stringify(this.consent));
      this.bannerIsOpen = false;
      this.configIsOpen = false;
    },
    load() {
      const consent = window.localStorage.getItem(STORAGE_ITEM_NAME);
      if (consent) {
        this.consent = JSON.parse(consent);
        this.finalize();
      } else {
        this.waitForDecision().then((decision) => {
          this.finalize();
        });
      }
    },
    getDecision() {
      if (window.parent !== window || window.location.search.includes('iniframe')) {
        this.consent.timestamp = new Date();
        return { statistics: true, other: true, pseudoconsent: true };
      }
      return this.consent.timestamp ? this.consent : false;
    },
    waitForDecision() {
      return new Promise((resolve) => {
        if (!this.consent.timestamp) {
          this.bannerIsOpen = true;
        }

        const watcher = this.$watch(
          () => this.consent.timestamp,
          (nv) => {
            if (nv) {
              resolve(this.consent);
              watcher(); // cleanup
            }
          }
        );
      });
    }
  }
};
</script>

<template>
  <div id="consent">
    <ConsentBanner
      v-if="bannerIsOpen"
      :class="{ bannerIsCovered: configIsOpen }"
      @open-config="openConfig"
      @save-choice="saveChoice" />
    <ConsentConfig
      v-if="configIsOpen"
      :statistics="consent.statistics"
      :other="consent.other"
      @close="closeConfig"
      @save-choice="saveChoice" />
  </div>
</template>

<style scoped>
#consent {
  position: relative;
  z-index: 30;
  line-height: 1.5rem;
}

.bannerIsCovered {
  filter: grayscale(90%);
}

:deep .button-cta {
  font-size: 0.875rem;
  padding: 0.375rem 1rem;
  min-width: 12rem;
  background-color: var(--color-primary, #0096db);
  color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
}

:deep .button-std {
  font-size: 0.875rem;
  padding: 0.375rem 1rem;
  min-width: 12rem;
  background-color: #fff;
  color: #424242;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  cursor: pointer;
}

@media (min-width: 768px) {
  :deep .button-std {
    font-size: 1rem;
  }

  :deep .button-cta {
    font-size: 1rem;
  }
}

:deep .button-cta:hover {
  background-color: var(--color-secondary, #e63957);
}
</style>
